import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ModalTrigger from '../common/ModalTrigger';
import RateInput from '../common/RateInput';
import { putRequest } from '../../requestUtils';
import SelectInputWithSymbol from '../common/SelectInputWithSymbol/SelectInputWithSymbol';
import dollarImage from '../../../assets/images/icons/dollar.svg';
import './ExecuteAgreementForProject.scss';
var requiredFields = ['netRate', 'travelRate', 'grossRate', 'grossTravelRate'];
var ExecuteAgreementForProject = /*#__PURE__*/function (_Component) {
  function ExecuteAgreementForProject(props) {
    var _this;
    _classCallCheck(this, ExecuteAgreementForProject);
    _this = _callSuper(this, ExecuteAgreementForProject, [props]);
    _this.state = {
      netRate: null,
      travelRate: null,
      grossRate: null,
      grossTravelRate: null,
      hourLimit: null,
      projectTakeRate: props.projectTakeRate,
      quickbooksPaymentTerm: props.quickbooksPaymentTerm
    };
    _this.handleCloseModal = _this.handleCloseModal.bind(_this);
    _this.handleUpdateProposal = _this.handleUpdateProposal.bind(_this);
    _this.updateTakeRate = _this.updateTakeRate.bind(_this);
    return _this;
  }
  _inherits(ExecuteAgreementForProject, _Component);
  return _createClass(ExecuteAgreementForProject, [{
    key: "ableToSubmit",
    value: function ableToSubmit() {
      var _this2 = this;
      return requiredFields.reduce(function (soFar, field) {
        return soFar && _this2.state[field];
      }, true);
    }
  }, {
    key: "handleCloseModal",
    value: function handleCloseModal() {
      this.setState({
        showModal: false
      });
    }
  }, {
    key: "handleUpdateProposal",
    value: function handleUpdateProposal() {
      var _this$props = this.props,
        csrfToken = _this$props.csrfToken,
        executeAgreementUrl = _this$props.executeAgreementUrl;
      var _this$state = this.state,
        netRate = _this$state.netRate,
        travelRate = _this$state.travelRate,
        grossRate = _this$state.grossRate,
        grossTravelRate = _this$state.grossTravelRate,
        hourLimit = _this$state.hourLimit,
        projectTakeRate = _this$state.projectTakeRate,
        quickbooksPaymentTerm = _this$state.quickbooksPaymentTerm;
      var rates = {
        net_rate: netRate * 100,
        travel_rate: travelRate * 100,
        gross_rate: grossRate * 100,
        gross_travel_rate: grossTravelRate * 100
      };
      putRequest(executeAgreementUrl, {
        rates: rates,
        hour_limit: hourLimit,
        clora_take_rate: projectTakeRate,
        quickbooks_payment_term: quickbooksPaymentTerm
      }, csrfToken).then(function () {
        window.location.reload();
      });
    }
  }, {
    key: "calculatedTakeRate",
    value: function calculatedTakeRate() {
      var _this$state2 = this.state,
        netRate = _this$state2.netRate,
        grossRate = _this$state2.grossRate;
      var rawRate = 1.0 - netRate / grossRate;
      return Math.round(rawRate * 10000) / 100;
    }
  }, {
    key: "updateTakeRate",
    value: function updateTakeRate() {
      if (isNaN(this.calculatedTakeRate()) || this.calculatedTakeRate() < 0) return;
      this.setState({
        projectTakeRate: this.calculatedTakeRate()
      });
    }
  }, {
    key: "handleChange",
    value: function handleChange(val, name) {
      this.setState(_defineProperty({}, name, val), this.updateTakeRate);
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      var _this$props2 = this.props,
        style = _this$props2.style,
        triggerText = _this$props2.triggerText,
        triggerStyle = _this$props2.triggerStyle,
        quickbooksPaymentTermOptions = _this$props2.quickbooksPaymentTermOptions;
      var _this$state3 = this.state,
        netRate = _this$state3.netRate,
        travelRate = _this$state3.travelRate,
        grossRate = _this$state3.grossRate,
        grossTravelRate = _this$state3.grossTravelRate,
        hourLimit = _this$state3.hourLimit,
        projectTakeRate = _this$state3.projectTakeRate,
        quickbooksPaymentTerm = _this$state3.quickbooksPaymentTerm;
      return /*#__PURE__*/React.createElement(ModalTrigger, {
        triggerText: triggerText,
        buttonStyles: "btn btn-sm ".concat(style, " ").concat(triggerStyle),
        submitButtonText: "Execute Agreement",
        submitDisabled: !this.ableToSubmit(),
        cancelButtonText: "Cancel",
        handleSubmit: this.handleUpdateProposal,
        triggerType: "link",
        idKey: "execute-agreement-for-project-modal",
        modalSize: "md"
      }, /*#__PURE__*/React.createElement("div", {
        className: "style-guide"
      }, /*#__PURE__*/React.createElement("div", {
        className: " mb-3 "
      }, /*#__PURE__*/React.createElement("h2", {
        className: "mb-1 required"
      }, "Employer Hourly Rate (Gross)"), /*#__PURE__*/React.createElement(RateInput, {
        id: "proposal-gross-rate",
        value: grossRate,
        onAnswerChange: function onAnswerChange(val) {
          return _this3.handleChange(val, 'grossRate');
        },
        placeholder: "Gross Hourly Rate"
      }, /*#__PURE__*/React.createElement("img", {
        className: "pe-2",
        src: dollarImage,
        alt: "dollar sign"
      }))), /*#__PURE__*/React.createElement("div", {
        className: " mb-3 "
      }, /*#__PURE__*/React.createElement("h2", {
        className: "mb-1 required"
      }, "Consultant Hourly Rate (Net)"), /*#__PURE__*/React.createElement(RateInput, {
        id: "proposal-net-rate",
        value: netRate,
        onAnswerChange: function onAnswerChange(val) {
          return _this3.handleChange(val, 'netRate');
        },
        placeholder: "Net Hourly Rate"
      }, /*#__PURE__*/React.createElement("img", {
        className: "pe-2",
        src: dollarImage,
        alt: "dollar sign"
      }))), /*#__PURE__*/React.createElement("div", {
        className: " mb-3 "
      }, /*#__PURE__*/React.createElement("h2", {
        className: "mb-1 required"
      }, "Employer Travel Rate (Gross)"), /*#__PURE__*/React.createElement(RateInput, {
        id: "proposal-gross-travel-rate",
        value: grossTravelRate,
        onAnswerChange: function onAnswerChange(val) {
          return _this3.handleChange(val, 'grossTravelRate');
        },
        placeholder: "Gross Travel Rate"
      }, /*#__PURE__*/React.createElement("img", {
        className: "pe-2",
        src: dollarImage,
        alt: "dollar sign"
      }))), /*#__PURE__*/React.createElement("div", {
        className: " mb-3 "
      }, /*#__PURE__*/React.createElement("h2", {
        className: "mb-1 required"
      }, "Consultant Travel Rate (Net)"), /*#__PURE__*/React.createElement(RateInput, {
        id: "proposal-travel-rate",
        value: travelRate,
        onAnswerChange: function onAnswerChange(val) {
          return _this3.handleChange(val, 'travelRate');
        },
        placeholder: "Net Travel Rate"
      }, /*#__PURE__*/React.createElement("img", {
        className: "pe-2",
        src: dollarImage,
        alt: "dollar sign"
      }))), /*#__PURE__*/React.createElement("div", {
        className: " mb-3 "
      }, /*#__PURE__*/React.createElement("h2", {
        className: "mb-1"
      }, "Monthly Hourly Limit (optional)"), /*#__PURE__*/React.createElement("div", {
        className: "input- w-50"
      }, /*#__PURE__*/React.createElement("input", {
        id: "proposal-hour-limit",
        type: "number",
        className: "form-control rate-input",
        value: hourLimit,
        onChange: function onChange(e) {
          return _this3.handleChange(e.target.value, 'hourLimit');
        },
        placeholder: "Max Hours"
      }))), /*#__PURE__*/React.createElement("div", {
        className: " mb-3 "
      }, /*#__PURE__*/React.createElement("h2", {
        className: "mb-1 required"
      }, "Project Take Rate"), /*#__PURE__*/React.createElement("div", {
        className: "input-group w-50"
      }, /*#__PURE__*/React.createElement("input", {
        id: "project-take-rate",
        type: "number",
        className: "form-control rate-input",
        value: projectTakeRate,
        placeholder: "Project Take Rate",
        readOnly: true
      }))), /*#__PURE__*/React.createElement(SelectInputWithSymbol, {
        label: /*#__PURE__*/React.createElement("h2", {
          className: "input-label",
          style: {
            color: '#007766'
          },
          required: true
        }, "Quickbooks Payment Term"),
        placeholder: "Quickbooks Payment Term",
        inputName: "quickbooksPaymentTerm",
        onChange: function onChange(e) {
          return _this3.handleChange(e.value, 'quickbooksPaymentTerm');
        },
        errors: "",
        containerWidth: "80%",
        value: {
          value: quickbooksPaymentTerm,
          label: quickbooksPaymentTerm
        },
        options: quickbooksPaymentTermOptions,
        containerClasss: "border-0"
      })));
    }
  }]);
}(Component);
ExecuteAgreementForProject.propTypes = {
  style: PropTypes.string,
  triggerStyle: PropTypes.string,
  triggerText: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  csrfToken: PropTypes.string.isRequired,
  executeAgreementUrl: PropTypes.string.isRequired,
  projectTakeRate: PropTypes.number.isRequired,
  quickbooksPaymentTerm: PropTypes.string.isRequired,
  quickbooksPaymentTermOptions: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    label: PropTypes.string.isRequired
  }))
};
ExecuteAgreementForProject.defaultProps = {
  triggerStyle: '',
  triggerText: 'Executed Agreement',
  style: '',
  quickbooksPaymentTermOptions: []
};
export default ExecuteAgreementForProject;